import i18n from '@/i18n';

const configModalRule = {
    id: '',
    title: '新規登録',
    titleBtnSave: '登録',
    model: false,
    scrollable: true,
    hideFooter: false,
    size: '2xl',
    validate: true
};

const shortCode = [
    '《キャンペーン名》',
    '《クライアント名》',
    '《年末年始休み》',
    '《キャンペーン開始》',
    '《キャンペーン終了》',
    '《対象商品名》',
    '《事務局開始》',
    '《事務局終了》',
    '《主催者(流通)名》',
    '《協賛メーカー》',
    '《EJOICAセレクトギフト》',
    '《クオカードペイ》',
    '《公式Twitterアカウント名》',
    '《公式Instagramアカウント名》',
    '《LINE公式アカウント名》',
    '《抽選(当選人数)》',
    '《賞品発送時期》',
    '《CP指定ハッシュタグ》',
    '《応募種別》',
    '《Amazon当選者数》',
    '《EJOICA当選者数》',
    '《QUO当選者数》',
    '《対象商品金額》',
    '《流通合計金額》',
    '《対象商品合計金額》',
    '《対象商品個数》',
    '《Amazonギフト》',
    '《公式アカウント・ID》'
];

const IF_CONDITION = ['AND', 'OR', 'NOT', 'AND NOT'];

const LIST_TYPE_CONDITION_RULE = [
    { id: 1, name: '共通' },
    { id: 2, name: 'クローズ' },
    { id: 3, name: '応募種別' }
];

function configForm() {
    return {
        configFieldOption: {
            trackBy: 'id',
            label: 'value',
            error: false,
            isRemove: false,
            errorField: '配置',
            valueSync: null,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },
        configFieldClassic: {
            trackBy: 'id',
            label: 'value',
            error: false,
            isRemove: false,
            errorField: '区分',
            valueSync: null,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },
        configFieldDetail: {
            error: false,
            valueSync: null,
            isRequired: false,
            errorField: '条文・細則',
            typesValidate: ['required']
        },
        configFieldLogicFormula: {
            error: false,
            valueSync: null,
            isRequired: false,
            errorField: i18n.t('screenRule.settingFomulator'),
            typesValidate: []
        }
    };
}

function initDataForm() {
    return {
        detail: '',
        logic_formula: '',
        option: null,
        classification: null,
        is_default: false
    };
}

function groupRulesByPlatform(ruleList) {
    const platformMap = new Map();
    ruleList.forEach((item) => {
        const uniquePlatforms = [...new Set(item.platform_values || [])];
        uniquePlatforms.forEach((platform) => {
            if (!platformMap.has(platform)) {
                platformMap.set(platform, {
                    platform_name: platform,
                    rules: []
                });
            }
            platformMap.get(platform).rules.push({
                id: item.id,
                rule: item.rule
            });
        });
    });
    return Array.from(platformMap.values());
}

function groupRulesByType(ruleList) {
    const result = [];
    const type1Rules = ruleList.filter((item) => item.type === 1);
    const type2Rules = ruleList.filter((item) => item.type === 2);
    const type3Rules = ruleList.filter((item) => item.type === 3);
    if (type1Rules.length > 0) {
        result.push({
            id: 1,
            type: 1,
            name_type: LIST_TYPE_CONDITION_RULE.find((x) => x.id === 1)?.name || '',
            rules: type1Rules
        });
    }
    if (type2Rules.length > 0) {
        result.push({
            id: 2,
            type: 2,
            name_type: LIST_TYPE_CONDITION_RULE.find((x) => x.id === 2)?.name || '',
            rules: type2Rules
        });
    }
    if (type3Rules.length > 0) {
        const type3Grouped = groupRulesByPlatform(type3Rules);
        result.push({
            id: 3,
            type: 3,
            name_type: LIST_TYPE_CONDITION_RULE.find((x) => x.id === 3)?.name || '',
            rules: type3Grouped
        });
    }
    return result;
}

export { configModalRule, shortCode, IF_CONDITION, LIST_TYPE_CONDITION_RULE, configForm, initDataForm, groupRulesByPlatform, groupRulesByType };
